export const RiskHomeIcon = () => {
   return (
      <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
         <rect className="cls-1" width="32" style={{ fill: 'none' }} height="32" />
         <path
            d="M16.6123,2.2138a1.01,1.01,0,0,0-1.2427,0L1,13.4194l1.2427,1.5717L4,13.6209V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM18,26H14V18h4Zm2,0V18a2.0023,2.0023,0,0,0-2-2H14a2.002,2.002,0,0,0-2,2v8H6V12.0615l10-7.79,10,7.8005V26Z"
            transform="translate(0 0)"
         />
      </svg>
   );
};

export const RiskMonitorIcon = () => {
   return (
      <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
         <path
            d="M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
            transform="translate(0 0)"
         />
         <path
            d="M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
            transform="translate(0 0)"
         />
         <rect width="32" style={{ fill: 'none' }} height="32" />
      </svg>
   );
};

export const RiskDiscoverIcon = () => {
   return (
      <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
         <rect x="12" y="11" width="2" height="6" />
         <rect x="7" y="13" width="2" height="4" />
         <rect x="2" y="7" width="2" height="10" />
         <path d="m30,28.5859l-7.5522-7.5522c1.5918-1.9082,2.5522-4.3604,2.5522-7.0337,0-6.0654-4.9346-11-11-11-2.4026,0-4.6853.7607-6.6013,2.2002l1.2012,1.5991c1.5669-1.1772,3.4343-1.7993,5.4001-1.7993,4.9626,0,9,4.0371,9,9s-4.0374,9-9,9c-2.8574,0-5.4819-1.312-7.2007-3.6001l-1.5991,1.2017c2.1001,2.7949,5.3076,4.3984,8.7998,4.3984,2.6733,0,5.1255-.9604,7.0337-2.5522l7.5522,7.5522,1.4141-1.4141Z" />
         <rect style={{ fill: 'none' }} width="32" height="32" />
      </svg>
   );
};

export const RiskReportsIcon = () => {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
         <path d="M25.7,9.3l-7-7C18.5,2.1,18.3,2,18,2H8C6.9,2,6,2.9,6,4v24c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V10C26,9.7,25.9,9.5,25.7,9.3z M18,4.4l5.6,5.6H18V4.4z M24,28H8V4h8v6c0,1.1,0.9,2,2,2h6V28z" />
         <rect x="10" y="22" width="12" height="2" />
         <rect x="10" y="16" width="12" height="2" />
         <rect style={{ fill: 'none' }} width="32" height="32" />
      </svg>
   );
};

export const RiskAnalyzeIcon = () => {
   return (
      <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
         <title>activity</title>
         <path d="M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z" />
         <rect style={{ fill: 'none' }} width="32" height="32" />
      </svg>
   );
};

export const RiskSettingsIcon = () => {
   return (
      <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
         <path
            d="M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
            transform="translate(0 0)"
         />
         <path
            d="M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
            transform="translate(0 0)"
         />
         <rect style={{ fill: 'none' }} width="32" height="32" />
      </svg>
   );
};
